module.exports = __webpack_public_path__ + "img/cafes.30a7f14b.jpg";